// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-1-oFAjh","modal_rounded":"modal_rounded-GkUZHjl","overlay":"overlay-1R-Y0np"};